import { useEffect, useState } from 'react';

/**
 * Extra reassurance that appears only if something is taking a while.
 *
 * ⚠ For calls that leave our infrastructure. A grid read goes out to the
 * customer's own Acumatica instance, and if that instance is switched off the
 * request sits in a TCP timeout for 10–20 seconds before failing. Measured
 * against a genuinely dead instance on 14 September 2026: a bare "Loading…"
 * for twenty seconds, with nothing to say whether it was working or wedged.
 *
 * Deliberately delayed rather than always shown. A warm read returns in well
 * under a second, and explaining the wait to someone who is not waiting is just
 * noise — the same reasoning as excluding host-recycle exceptions from the
 * error alert.
 */
export function SlowHint({
  afterMs = 6000,
  children,
}: {
  afterMs?: number;
  children: React.ReactNode;
}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), afterMs);
    return () => clearTimeout(timer);
  }, [afterMs]);

  if (!show) return null;
  return <p className="muted small">{children}</p>;
}
